var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenshiftAzure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e93b32ab-e2ba-431e-bcb5-b6ade3b66965",
    "data-name": "FxSymbol0-087",
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.25in",
    height: "0.25in",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.267,8.167,2.41,9.21a7.172,7.172,0,0,0,.233,1.361l2.71-.981a5.607,5.607,0,0,1-.086-1.423M17.9,5a8.8,8.8,0,0,0-.687-1.177L14.352,4.865A5.814,5.814,0,0,1,15.2,5.993C15.186,5.981,17.9,5,17.9,5Z",
    fill: "#c32034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.612,4.19a5.358,5.358,0,0,1,1.545,1.1l2.858-1.042A8.16,8.16,0,0,0,1.239,9.634L4.1,8.592a5.24,5.24,0,0,1,.478-1.84A5.3,5.3,0,0,1,11.612,4.19",
    fill: "#db212f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.814,10.487.1,11.468A8.5,8.5,0,0,0,1.38,14.24L4.225,13.2a5.366,5.366,0,0,1-1.411-2.71",
    fill: "#ea2227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.66,9.408a5.514,5.514,0,0,1-.479,1.84,5.3,5.3,0,0,1-7.05,2.562,5.358,5.358,0,0,1-1.545-1.1L2.741,13.749A8.064,8.064,0,0,0,5.929,16.4,8.158,8.158,0,0,0,17.517,8.366Z",
    fill: "#db212f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.362,5.917l-2.71.981a5.3,5.3,0,0,1,.662,2.992l2.845-1.042a8.26,8.26,0,0,0-.8-2.931",
    fill: "#ea2227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.417,9.2l2.845-1.03-.012.564L2.5,9.753ZM14.349,4.848l2.894-.981.307.442-2.808.98c-.013.013-.393-.441-.393-.441Z",
    fill: "#ad213a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.726,13.744l2.845-1.018.858.8-2.992,1.1C3.45,14.627,2.726,13.744,2.726,13.744Zm14.83-5.356-2.894,1.03-.208,1.141,3.09-1.08C17.531,9.467,17.556,8.388,17.556,8.388Z",
    fill: "#ba2034"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenshiftAzure);
export default __webpack_public_path__ + "static/media/openshift_azure.82ebce5243565da1fe3ef1c8022188ae.svg";
export { ForwardRef as ReactComponent };